module.exports = __webpack_public_path__ + "img/home_carousel_image_5.38d73d18.png";